<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    :title="isSyncDetail ? '明细查看' : '明细输入'"
    width="70%"
    height="70%"
    @show="showModal"
  >
    <div class="textareaContainer">
      <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
        <el-form-item label="需求描述" prop="requirementDesc">
          <el-input
            type="textarea"
            rows="15"
            v-model="form.requirementDesc"
            autocomplete="off"
            :placeholder="placeholderConfig.input"
            :disabled="isDisabled || isManagementAndDontMyCompany"
          ></el-input>
          <template slot="error" slot-scope="slot">
            <errorTooltip :content="slot.error"></errorTooltip>
          </template>
        </el-form-item>
        <el-form-item label="建议解决方案" v-if="!isSyncDetail" prop="suggestedSolutions">
          <el-input
            type="textarea"
            rows="5"
            v-model="form.suggestedSolutions"
            autocomplete="off"
            :placeholder="placeholderConfig.input"
            :disabled="isDisabled"
          ></el-input>
          <template slot="error" slot-scope="slot">
            <errorTooltip :content="slot.error"></errorTooltip>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div class="buttonContainer" v-if="isSyncDetail">
      <el-button @click="handleCancle" size="mini">关闭 </el-button>
    </div>
    <div class="buttonContainer" v-else>
      <el-button @click="handleCancle" size="mini">取消 </el-button>
      <el-button @click="handleCommit" :disabled="isDisabled" size="mini" type="primary">确认 </el-button>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  name: 'DateInput',
  props: {
    // 修改行
    updateRow: {
      type: Object
    },
    isDisabled: {
      type: Boolean,
      default: true
    },
    // 是否是同步版本时查看明细
    isSyncDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formVisible: false,
      form: {
        requirementDesc: '',
        suggestedSolutions: ''
      },
      rules: {
        requirementDesc: [
          { required: true, message: '请输入需求描述', trigger: 'change' }
          // {
          //   min: 0,
          //   max: 128,
          //   message: '长度在 0 到 128 个字符',
          //   trigger: 'change'
          // }
        ],
        suggestedSolutions: [
          { required: true, message: '请输入需求描述', trigger: 'change' }
          // {
          //   min: 0,
          //   max: 128,
          //   message: '长度在 0 到 128 个字符',
          //   trigger: 'change'
          // }
        ]
      },
      // 如果是管理员或者运维人员需要编辑建议解决方案需要把需求描述输入禁用
      isManagementAndDontMyCompany: false
    }
  },
  methods: {
    // 打开窗口时
    showModal() {
      if (this.updateRow['requirementDesc']) {
        this.form.requirementDesc = this.updateRow['requirementDesc']
      } else {
        this.form.requirementDesc = ''
      }
      if (this.updateRow['suggestedSolutions']) {
        this.form.suggestedSolutions = this.updateRow['suggestedSolutions']
      } else {
        this.form.suggestedSolutions = ''
      }
      // 判断是否是管理员进入 ==> 如果是运维人员或管理员进入且不是本单位提的问题则禁用需求描述这一列的输入，只编辑建议解决方案
      if (
        this.updateRow['userCompany'] !== this.$store.state.userInfo.company &&
        ['管理', '运维'].includes(this.$store.state.userInfo.gangWei)
      ) {
        this.isManagementAndDontMyCompany = true
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    // 取消
    handleCancle() {
      this.formVisible = false
    },
    // 确认
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      // this.$emit("sureHandler", this.form);
      this.updateRow['requirementDesc'] = this.form.requirementDesc
      this.updateRow['suggestedSolutions'] = this.form.suggestedSolutions
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    // 校验
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    }
  }
}
</script>
<style lang="less" scoped>
.textareaContainer {
  overflow: auto;
  height: calc(100% - 38px);
  width: 100%;
}
.buttonContainer {
  box-sizing: border-box;
  padding-top: 10px;
  height: 38px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>
